import React from 'react';
import { oohData } from '../utils/oohData';
import { BrainIcon } from 'lucide-react';
export const OverallAssessment: React.FC = () => {
  const {
    overallAssessment
  } = oohData;
  return <div className="bg-white p-8 rounded-xl shadow-sm border-t-4 border-t-[#1E90FF]" data-id="element-208">
      <div className="flex items-center space-x-3 mb-6" data-id="element-209">
        <BrainIcon className="export-icon-down h-6 w-6 text-[#1E90FF]" data-id="element-210" />
        <h3 className="text-xl font-semibold text-gray-900" data-id="element-211">
          Overall Assessment
        </h3>
      </div>
      <div className="prose prose-lg w-full text-gray-700" data-id="element-212">
        <p className="leading-relaxed" data-id="element-213">{overallAssessment}</p>
      </div>
    </div>;
};